import { useInventoryStore } from '../store/inventorySlice';
import { useChestStore } from '../store/chestSlice';
import { ITEMS } from '../data/inventory.config';
import { logger } from './LoggerService';

// Grants a catalog item to the player, overflowing to the hub chest when the
// inventory is full so a granted item is never silently lost. Used by the dev
// `/give` command and by in-game reward grants (e.g. dungeon-completion
// grimoires). Only handles items from the `ITEMS` catalog (materials,
// consumables, key items) — equipment has its own lifecycle.
// Returns true if any quantity overflowed to the chest.
export function giveItem(itemId: string, quantity: number = 1): boolean {
  const def = ITEMS[itemId];
  if (!def) {
    logger.warn(`giveItem : item inconnu « ${itemId} »`);
    return false;
  }
  const leftover = useInventoryStore.getState().addItem(itemId, quantity);
  if (leftover > 0) {
    useChestStore.getState().addItem(itemId, leftover);
    return true;
  }
  return false;
}
